import {COLORS} from '@/utils/constants';
import {entrepreneursObtainedFundsChartCalculation} from './common/entrepreneurs-obtained-funds-chart-calculation';

const transformData = [
    {
        name: 'Family & friends',
        key: 'question18',
    },
    {
        name: 'Business Angels',
        key: 'question23',
    },
    {
        name: 'Crowdfunding',
        key: 'question28',
    },
    {
        name: 'Incubators and Accelerators',
        key: 'question34',
    },
    {
        name: 'NGO’s loans',
        key: 'question39',
    },
    {
        name: 'NGO’s grants',
        key: 'question44',
    },
    {
        name: 'Public subsidies',
        key: 'question49',
    },
    {
        name: 'Public grants',
        key: 'question54',
    },
    {
        name: 'Venture capital',
        key: 'question59',
    },
    {
        name: 'Microfinance',
        key: 'question64',
    },
    {
        name: 'Financial institutions (banks)',
        key: 'question69',
    },
    {
        name: 'Other',
        key: 'question74',
    },
];

const series = [
    {
        name: 'Yes',
        value: 'item1',
        color: COLORS.green,
    },
    {
        name: 'No',
        value: 'item3',
        color: COLORS.gray,
    },
    {
        name: 'Pending',
        value: 'item2',
        color: COLORS.orange,
    }
]

/**
 * Survey: 
 * question: Did you receive the funds?
 * 
 * == final
 * question18
 * question23
 * question28
 * question34
 * question39
 * question44
 * question49
 * question54
 * question59
 * question64
 * question69
 * question74
 * 
 * @param props 
 * @returns 
 */
export const entrepreneursFinalObtainedFundsChartCalculation = (props: any): Highcharts.Options => {
    return entrepreneursObtainedFundsChartCalculation(props.finalSubmissions, transformData, series);
}